import * as React from 'react';
import { isMobile } from 'react-device-detect';
import parse from 'html-react-parser';
import { Block, Heading, Icon, Text } from '../../../../../../../components';
import activatePaymentImage from '../../../../../../../../assets/illustrations/activate_payment.svg';
import activatePaymentDskImage from '../../../../../../../../assets/illustrations/activate_payment_d.svg';
import paymentActivatedImage from '../../../../../../../../assets/illustrations/payment_activated.svg';
import paymentActivatedDskImage from '../../../../../../../../assets/illustrations/payment_activated_d.svg';
import requestInProgressImage from '../../../../../../../../assets/illustrations/request_in_progress.svg';
import requestInProgressDskImage from '../../../../../../../../assets/illustrations/request_in_progress_dsk.svg';
import requestApprovedImage from '../../../../../../../../assets/illustrations/updatePhoto-approved.svg';
import requestRejectedImage from '../../../../../../../../assets/illustrations/updatePhoto-rejected.svg';
import certificateDoneImage from '../../../../../../../../assets/illustrations/certificate_done.svg';
import certificateDoneDskImage from '../../../../../../../../assets/illustrations/certificate_done_d.svg';
import { ActionableButton } from '../../info/components';

const CardInProgress = ({
  activatePayment,
  paymentActivated,
  isFinished,
  onClick,
  titleText,
  subtitleText,
  textInfo,
  isPendingAtention,
  isComplete,
  isApproved,
  availableDays
}: any) => {
  let title = titleText;
  let subtitle = subtitleText;
  let image = isMobile ? activatePaymentImage : activatePaymentDskImage;
  let buttonText = '';
  if (activatePayment) {
    title = titleText || 'Genera el cargo de tu trámite activando tu pago';
    subtitle =
      subtitleText ||
      'Recuerda que una vez realizado el pago podrás descargar tu constancia.';
    image = isMobile ? activatePaymentImage : activatePaymentDskImage;
    buttonText = 'Activar';
  } else if (paymentActivated) {
    title = titleText || 'El pago ha sido activado';
    subtitle =
      subtitleText ||
      'Recuerda que una vez realizado el pago podrás descargar tu constancia.';
    image = isMobile ? paymentActivatedImage : paymentActivatedDskImage;
    buttonText = 'Ir a pagos';
  } else if (isFinished) {
    title = titleText || 'Tu constancia está lista';
    subtitle =
      subtitleText ||
      'El documento se ha generado con éxito. Recuerda que estará vigente esta descarga por';
    image = isMobile ? certificateDoneImage : certificateDoneDskImage;
    buttonText = 'Descargar';
  } else if (isComplete && isApproved) {
    title = titleText || 'Tu constancia está lista';
    subtitle = subtitleText || 'El documento se ha generado con éxito.';
    image = isMobile ? certificateDoneImage : certificateDoneDskImage;
    buttonText = 'Descargar';
  }

  if (isPendingAtention)
    image = isMobile ? requestInProgressImage : requestInProgressDskImage;
  if (isComplete && isApproved) image = requestApprovedImage;
  if (isComplete && !isApproved) image = requestRejectedImage;
  return (
    <Block customized className="card" maxWidth={isMobile ? '100%' : '496px'}>
      <Block
        customized
        maxWidth={isMobile ? '100%' : '496px'}
        backgroundColor="#fff"
        padding="24px"
        borderRadius="8px"
        margin="16px 0px 32px 0px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        shadow="0px 2px 8px -4px rgba(176, 192, 202, 0.2)"
      >
        <Block
          customized
          backgroundColor="#D5E5F0"
          borderRadius="8px"
          margin="0px 0px 16px 0px"
        >
          <img src={image} alt="chevron" />
        </Block>
        <Heading
          text={title}
          level={2}
          color="var(--text-text02)"
          size={18}
          lineHeight={28}
          fontWeight="900"
          className=""
          align="center"
          width="100%"
        />
        {!textInfo && (
          <Block
            customized
            flexDirection="row"
            alignItems="flex-start"
            // justifyContent={isComplete && !isApproved ? 'flex-start' : 'center'}
            borderRadius="8px"
            margin="12px 0px 0px 0px"
            // maxWidth={isMobile ? '100%' : '100%'}
            maxWidth="100%"
            backgroundColor="#ECF4F9"
            padding="8px 16px"
          >
            <Block
              customized
              margin="1px 9px 0px 0px"
              style={{ width: 'auto' }}
            >
              <Icon name="alert-circle" size={15} />
            </Block>
            <Block style={{ width: '100%' }}>
              <Text
                color="#161D1F"
                fontSize="12px"
                lineHeight="16px"
                fontWeight="400"
                witdh="100%"
              >
                {subtitle} {isFinished && <span>30 días.</span>}
              </Text>
            </Block>
          </Block>
        )}
        {textInfo && (
          <Block
            customized
            flexDirection="row"
            alignItems="flex-start"
            justifyContent="center"
            borderRadius="8px"
            // maxWidth={isMobile ? '100%' : '100%'}
            maxWidth="100%"
            padding="8px 0px"
          >
            <Text
              color="#161D1F"
              fontSize="14px"
              lineHeight="20px"
              fontWeight="400"
              witdh="100%"
              textAlign="center"
            >
              {!availableDays ? (
                <>
                  {parse(subtitle)}
                  {isFinished && (
                    <strong className="bold__progress"> 30 días.</strong>
                  )}
                </>
              ) : (
                <div className="download__disabled">
                  <p>
                    El documento generado, ya no se encuentra disponible para
                    descargar, contáctate con nosotros.
                  </p>
                  <>
                    <b>0801 19600</b> o <b>315 9600</b>
                  </>
                </div>
              )}
            </Text>
          </Block>
        )}
        {onClick && !availableDays && (
          <ActionableButton
            enabled
            text={buttonText}
            marginTop={32}
            onClick={onClick}
          />
        )}
        {/* {comentary && (
          <Block
            customized
            flexDirection="row"
            alignItems="center"
            justifyContent={isComplete && !isApproved ? 'flex-start' : 'center'}
            borderRadius="8px"
            margin="8px 0px 0px 0px"
            maxWidth={isMobile ? '100%' : '100%'}
          >
            <ul style={{ listStyle: 'unset', marginLeft: 16 }}>
              <li>
                <Text
                  color="#161D1F"
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="400"
                >
                  {comentary}
                </Text>
              </li>
            </ul>
          </Block>
        )} */}
      </Block>
    </Block>
  );
};

export default CardInProgress;
